import React from 'react'
import Typography from '@material-ui/core/Typography';
import { Divider } from '@material-ui/core';

function EducationContent() {
    return (
        <>
            <Typography p={1} m={1} variant="h5 " component="h2" gutterBottom>
                Kabi Nazrul College
            </Typography>
            <Typography variant="body1" component="h2" gutterBottom>
                Honours
            </Typography>
            <Typography variant="body2" component="h2" gutterBottom>
                Present Student
            </Typography>
            <Typography variant="body2" component="h2" gutterBottom>
                2018 - Present
            </Typography>
            <Divider />
            <Typography p={1} m={1} variant="h5 " component="h2" gutterBottom>
                Cambrian College
            </Typography>
            <Typography variant="body1" component="h2" gutterBottom>
                Hsc
            </Typography>
            <Typography variant="body2" component="h2" gutterBottom>
                GPA - 4.17
            </Typography>
            <Typography variant="body2" component="h2" gutterBottom>
                2017-2018
            </Typography>
            <Divider />
            <Typography p={1} m={1} variant="h5 " component="h2" gutterBottom>
                BAF Shaheen Collage,Pkp
            </Typography>
            <Typography variant="body1" component="h2" gutterBottom>
                Ssc
            </Typography>
            <Typography variant="body2" component="h2" gutterBottom>
                GPA - 5.00
            </Typography>
            <Typography variant="body2" component="h2" gutterBottom>
                2013-2016
            </Typography>
            <Divider />
        </>
    )
}

export default EducationContent
